import React from 'react';
import Chevron from './Chevron';

export default class DashboardButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDropdown: false,
    };
  }

  componentDidMount = () => {
    // Listen for our custom event to know when another dropdown has been opened
    document.addEventListener(
      'dashboard-button-open',
      this.handleOtherButtonOpen
    );

    const { buttonDetails, button } = this.props;
    const { isDropdown } = buttonDetails;
    this.setState(
      {
        isDropdown,
      },
      () => {
        if (this.state.isDropdown) {
          this.setState({
            [`display${button}`]: false,
          });
        }
      }
    );
  };

  componentWillUnmount = () => {
    // Clean up the event listener to prevent memory leaks
    document.removeEventListener(
      'dashboard-button-open',
      this.handleOtherButtonOpen
    );
  };

  /**
   * This handler listens for the custom event. If the event was dispatched
   * by a different button instance, this instance will close its dropdown.
   */
  handleOtherButtonOpen = (e) => {
    const { button } = this.props;
    // Check if the event was fired by a different button
    if (e.detail.buttonId !== button) {
      this.setState({ [`display${button}`]: false });
    }
  };

  /**
   * Toggles the dropdown for the current component instance.
   * If it's being opened, it dispatches a global event to notify all other instances.
   */
  handleToggle = () => {
    const { button } = this.props;
    const isOpening = !this.state[`display${button}`];

    // If we are opening the dropdown, dispatch an event with this button's unique ID.
    // All other instances will hear this and close themselves.
    if (isOpening) {
      document.dispatchEvent(
        new CustomEvent('dashboard-button-open', {
          detail: {
            buttonId: button,
          },
        })
      );
    }

    // Finally, toggle the state for this component instance
    this.setState({ [`display${button}`]: isOpening });
  };

  handleAdmissionsOption = (option) => {
    const { button } = this.props;
    if (option && option.value) {
      this.setState({ [`display${button}`]: false });
      window.open(option.value, '_blank', 'noopener,noreferrer');
      // ADDED THIS LINE: Close the dropdown after the option is clicked.
    }
  };

  render() {
    const { buttonDetails, button } = this.props;
    const { isDropdown } = this.state;
    const caretTransform = this.state[`display${button}`] ? 270 : 90;
    const dropdownLabel = isDropdown ? buttonDetails.dropdownLabel : null;
    return !isDropdown ? (
      <button
        type="button"
        tabIndex={0}
        onClick={() => {
          this.handleAdmissionsOption(buttonDetails);
        }}
        className="button--primary take-action-learn-more-button margin-right"
      >
        {buttonDetails.label}
      </button>
    ) : (
      <div className="admissions-options">
        <button
          type="button"
          tabIndex={0}
          name={`${button}-dropdown`}
          // The button now calls the new handleToggle method on click
          onClick={this.handleToggle}
          className="button--primary take-action-learn-more-button margin-right"
        >
          {dropdownLabel}
          <Chevron
            color="#707070"
            transform={`rotate(${caretTransform}deg)`}
            idName={button}
            ariaLabel={`${
              this.state[`display${button}`]
                ? 'Click to close dropdown'
                : 'Click to open dropdown'
            }`}
          />
        </button>
        <div className="dropdown-options">
          {this.state[`display${button}`]
            ? buttonDetails.childButtons.map((option) => {
                return (
                  <div
                    role="button"
                    tabIndex={0}
                    className="individual-option"
                    key={option.label}
                    onClick={() => {
                      this.handleAdmissionsOption(option);
                    }}
                    onKeyDown={(e) => {
                      if (['Enter'].includes(e.key))
                        this.handleAdmissionsOption(option);
                    }}
                  >
                    {option.label}
                  </div>
                );
              })
            : null}
        </div>
      </div>
    );
  }
}
